import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/NavBar';
import { Button } from '../components/ui/button';
import { Wrench, ArrowLeft } from 'lucide-react';

export default function Maintenance({ title = 'Bu sayfa' }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <NavBar />
      <div className="max-w-2xl mx-auto px-4 py-24 text-center">
        <div className="glass-card rounded-2xl p-12">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center mb-6">
            <Wrench className="w-7 h-7 text-amber-400" />
          </div>
          <h1 className="text-3xl font-bold mb-2">{title} Bakımda</h1>
          <p className="text-muted-foreground mb-8">
            Bu özellik şu anda geliştirme aşamasındadır. Çok yakında hizmetinizde olacak.
          </p>
          <Link to="/dashboard">
            <Button variant="outline" className="border-white/10" data-testid="maintenance-back-btn">
              <ArrowLeft className="w-4 h-4 mr-2" /> Panele Dön
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
